import axios from 'axios';

const saveProblemDetail = (data) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/crop/problemDetail`, data)
    .then(res => res)
    .catch(err => err);
};

export default saveProblemDetail;
